import React, { Fragment, useEffect } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useSticky,
} from "react-table"
import {
  Table,
  Row,
  Col,
  Button,
  Input,
  CardBody,
  FormGroup,
  Label,
  InputGroup,
  Modal,
  Form
} from "reactstrap"
import { Filter, DefaultColumnFilter } from "./filters"
import JobListGlobalFilter from "./GlobalSearchFilter"
import { Link } from "react-router-dom"
import { useState } from "react"
import { subscribe } from "../../common/events"

import moment from "moment"
import Cookies from "js-cookie"

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  isJobListGlobalFilter,
  setFilter
}) {
  const count = preGlobalFilteredRows.length
  const [value, setValue] = React.useState(globalFilter)
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
  }, 200)

  return (
    <React.Fragment>
      <Col md={10}>
        <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Search this table
              </span>
              <input
                onChange={e => {
                  setValue(e.target.value)
                  //onChange(e.target.value)

                }}

                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setFilter(e.target.value || undefined);
                  }
                }}
                onBlur={(e) => {
                  setFilter(e.target.value || undefined);        
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={"Type to search.."}
                value={value || ""}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </Col>
      {isJobListGlobalFilter && <JobListGlobalFilter />}
    </React.Fragment>
  )
}

const QuedTableContainer = ({
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  isAddOptions,
  isAddUserList,
  handleOrderClicks,
  handleUserClick,
  handleCustomerClick,
  isAddCustList,
  customPageSize,
  className,
  customPageSizeOptions,
  renderRowSubComponent,
  useSticky,
  refreshTable,
  searchToday,
  searchMonth,
  searchCustom,
  searchWeek,
  includeAllApptSts,
  setIncludAllApptSts,
  setActiveSearch,
  loading,
  getTrProps,
  queryParam,
  totalRows,
  onPageChange,
  pageNumber,
  currentSortBy,
  currentSortDesc
}) => {
  const computedPageCount = Math.ceil((totalRows || 0) / (customPageSize || 50)) || 0;
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    visibleColumns,
    state: { pageIndex, pageSize, filters, sortBy },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      manualPagination: true,
      manualFilters: true,
      manualSortBy: true,
      disableSortBy: false,
      disableMultiSort: true,
      pageCount: computedPageCount,
      initialState: {
        pageIndex: pageNumber,
        pageSize: customPageSize,
        sortBy: currentSortBy ? [{ id: currentSortBy, desc: currentSortDesc }] : [],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )

  const [showFilter, setShowFilter] = useState(false)
  const [expandedrow, setExpandedRow] = useState()

  useEffect(() => {
    subscribe("hideExpandedRow", () => setExpandedRow(null));

    if (typeof onPageChange === "function") {
      onPageChange(pageIndex, pageSize, filters, sortBy);
    }

  }, [filters, sortBy])





  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""
  }

const onChangeInSelect = event => {
  const newSize = Number(event.target.value);
  setPageSize(newSize);
  gotoPage(0);
  if (typeof onPageChange === "function") {
    onPageChange(0, newSize, filters, currentSortBy ? [{ id: currentSortBy, desc: currentSortDesc }] : []);
  }
}

const onChangeInInput = event => {
  const page = event.target.value ? Number(event.target.value) - 1 : 0
  gotoPage(page)
  if (typeof onPageChange === "function") {
    onPageChange(page, pageSize, filters, currentSortBy ? [{ id: currentSortBy, desc: currentSortDesc }] : []);
  }
}

  const handleRowClick = row => {
    if (expandedrow === row.id) {
      setExpandedRow(null)
      row.toggleRowExpanded()
    } else {
      setExpandedRow(row.id)
    }
  }

  const toggleFilter = () => {
    setShowFilter(!showFilter)
  }

  const refreshMe = () => {
    setExpandedRow(null)
    refreshTable()
  }

  const searchWk = () => {
    setExpandedRow(null)
    searchWeek();
  }

  const searchTday = () => {
    setExpandedRow(null)
    searchToday("allFuture")
  }

  const searchMth = () => {
    setExpandedRow(null)
    searchMonth("month")
  }

  const seachCustomDate = () => {
    setExpandedRow(null);
    searchCustom()
  }

  const handleIncludeAllApptSts = (val) => {
    setIncludAllApptSts(val)
  }







  return (
    <Fragment>
      <Row className="mb-2">
        <Col md={customPageSizeOptions ? 2 : 2}>
          <select
            className="form-select"
            value={pageSize}
            onChange={onChangeInSelect}
            disabled
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col>
          {/* <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
            isJobListGlobalFilter={isJobListGlobalFilter}
          /> */}
        </Col>
        <Col md={4}>
          <div className="d-flex justify-content-between">
            <div className="btn-group " role="group">
              <input
                type="radio"
                className="btn-check btn-sm"
                name="btnradio"
                id="btnradio1"
                autoComplete="off"
                defaultChecked
                onClick={searchTday}
              />
              <label className="btn btn-secondary btn-sm" htmlFor="btnradio1">
                All Future
              </label>

              <input
                type="radio"
                className="btn-check btn-sm"
                name="btnradio"
                id="btnradio2"
                autoComplete="off"
                onClick={searchWk}
              />
              <label className="btn btn-secondary btn-sm" htmlFor="btnradio2">
                Next 7 Days
              </label>

              <input
                type="radio"
                className="btn-check btn-sm"
                name="btnradio"
                id="btnradio3"
                autoComplete="off"
                onClick={searchMth}
              />
              <label className="btn btn-secondary btn-sm" htmlFor="btnradio3">
                Next 30 Days
              </label>

              <input
                type="radio"
                className="btn-check btn-sm"
                name="btnradio"
                id="btnradio4"
                autoComplete="off"
                onClick={seachCustomDate}
              />

              <label className="btn btn-secondary btn-sm" htmlFor="btnradio4">
                Custom Days
              </label>

            </div>
            {Cookies.get("role") == "admin" && <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="defaultCheck1"
                checked={includeAllApptSts}
                onClick={() => {
                  handleIncludeAllApptSts(!includeAllApptSts)
                }}
              />
              <label
                className="form-check-label"
                htmlFor="defaultCheck1"
              >
                Show all appointment status
              </label>
            </div>}
          </div>
        </Col>
        <Col>
          <div className="text-sm-end">
            {/* <span style={{ marginRight: "20px" }}>
              <Link to="#" onClick={toggleFilter}>
                <i className="fa fa-filter" />
              </Link>
            </span> */}

            <Link to="#" onClick={refreshMe}>
              <i className="fas fa-sync-alt" />
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <div>
            <p>
              Total {totalRows} records found from{" "}
              <span className="text-primary">
                {queryParam && queryParam.fromDate}{" "}
              </span>{" "}
              to{" "}
              <span className="text-primary">
                {queryParam && queryParam.toDate}
              </span>
            </p>
          </div>
        </Col>
      </Row>

      <div className="table-responsive react-table">
        <Table bordered hover {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    style={{
                      width: column.width + "px",
                      maxWidth: column.maxWidth + "px!important",
                    }}
                  >
                    <div className="mb-2" {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                    {showFilter && <Filter column={column} />}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {loading && <div>Loading....</div>}

            {!loading &&
              page.map(row => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr
                      {...row.getToggleRowExpandedProps()}
                      onClick={() => handleRowClick(row)}
                    >
                      {row.cells.map(cell => {
                        return (
                          <td
                            key={cell.id}
                            {...cell.getCellProps()}
                            style={cell.column.style}
                          >
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                    {row.id === expandedrow ? (
                      <tr>
                        <td colSpan={visibleColumns.length}>
                          {/*
                            Inside it, call our renderRowSubComponent function. In reality,
                            you could pass whatever you want as props to
                            a component like this, including the entire
                            table instance. But for this example, we'll just
                            pass the row
                          */}
                          {renderRowSubComponent({ row })}
                        </td>
                      </tr>
                    ) : null}
                  </Fragment>
                )
              })}
          </tbody>
        </Table>
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center">
      <Col className="col-md-auto">
        <div className="d-flex gap-1">
          <Button
            color="primary"
            onClick={() => {

              if (typeof onPageChange === "function") {
                onPageChange(0, pageSize, filters, currentSortBy ? [{ id: currentSortBy, desc: currentSortDesc }] : []);
              }
              gotoPage(0);
            }}
            disabled={!canPreviousPage}
          >
            {"<<"}
          </Button>
          <Button
            color="primary"
            onClick={() => {
              const newPage = pageIndex - 1;

              if (typeof onPageChange === "function") {
                onPageChange(newPage, pageSize, filters, currentSortBy ? [{ id: currentSortBy, desc: currentSortDesc }] : []);
              }
              previousPage();
            }}
            disabled={!canPreviousPage}
          >
            {"<"}
          </Button>
        </div>
      </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page{" "}
          <strong>
            {pageIndex + 1} of {computedPageCount}
          </strong>
        </Col>
        <Col className="col-md-auto">
          <Input
            type="number"
            min={1}
            style={{ width: 70 }}
            max={computedPageCount}
            defaultValue={pageNumber+1}
            onChange={onChangeInInput}
          />
        </Col>

        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={() => {
                const newPage = pageIndex + 1;

                if (typeof onPageChange === "function") {
                  onPageChange(newPage, pageSize, filters, currentSortBy ? [{ id: currentSortBy, desc: currentSortDesc }] : []);
                }
                nextPage();
              }}
              disabled={!canNextPage}
            >
              {">"}
            </Button>
            <Button
              color="primary"
              onClick={() => {
                const lastPage = pageCount - 1;

                if (typeof onPageChange === "function") {
                  onPageChange(lastPage, pageSize, filters, currentSortBy ? [{ id: currentSortBy, desc: currentSortDesc }] : []);
                }
                gotoPage(lastPage);
              }}
              disabled={!canNextPage}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  )
}

QuedTableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default QuedTableContainer
